import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import "./style.css";

interface MultiSiteGroupInfoProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const MultiSiteGroupInfo: React.FC<MultiSiteGroupInfoProps> = ({
  formData,
  setFormData,
}) => {
  const siteInformation = [
    {
      title: "Management system",
      description:
        "(e.g. training programs for internal auditors, internal audit schedule, etc.)",
    },
    {
      title: "Material sourcing",
      description:
        "(e.g. training programs for internal auditors, internal audit schedule, etc.)",
    },
    {
      title: "Management of non-conformities",
      description: "",
    },
    {
      title: "Site relationships, addition/removal process",
      description: "",
    },
  ];

  return (
    <>
      <div className="multi-site-header">
        <Form.Label className="me-2" style={{ marginBottom: "4px" }}>
          Multi-Site / Group Information
        </Form.Label>
        <Form.Check
          type="checkbox"
          id="na-checkbox"
          label="N/A"
          className="na-checkbox"
          disabled
          defaultChecked={formData.MultiSiteGroupInfo.Multi_Site_Group_Information__c}
        />
      </div>

      <div className="p-3">
        <p className="multi-site-description-label">
          General description of how the chain of custody is controlled at the
          group or multisite level
        </p>
        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Add a description..."
          value={formData.MultiSiteGroupInfo.Description_Group_Multisite_Level__c || "--"}
          disabled
        />
        <div className="mt-5">
          <header className="multi-site-desc-header">Description</header>
          <Row className="p-0 m-0">
            {siteInformation.map((item, index) => (
              <React.Fragment key={index}>
                <Col xs={4} className="multi-site-desc-cell">
                  <div className="multi-site-desc-title">{item.title}</div>
                  <span className="multi-site-description">
                    {item.description}
                  </span>
                </Col>



                <Col xs={8} className="multi-site-desc-cell">
                <div className="audit-details-table-cell">{index === 0 && formData.MultiSiteGroupInfo.Describe_Management_System__c}</div>
                <div className="audit-details-table-cell">{index === 1 && formData.MultiSiteGroupInfo.Describe_Material_sourcing__c}</div>
                <div className="audit-details-table-cell">{index === 2 && formData.MultiSiteGroupInfo.Describe_Management_of_non_conformities__c}</div>
                <div className="audit-details-table-cell">{index === 3 && formData.MultiSiteGroupInfo.Site_relationships_addition_removal_p__c}</div>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
      </div>
    </>
  );
};

export default MultiSiteGroupInfo;
